import { HttpErrorResponse } from "@angular/common/http";
import Swal from "sweetalert2";
import { Injectable, Injector, OnDestroy } from "@angular/core";
import { Observable } from "rxjs";
import { io, ManagerOptions, Socket, SocketOptions } from "socket.io-client";
import { environment } from "./../../../environments/environment";
import { AuthenticationService } from "./authentication.service";
import { Metadata } from "../shared/types/Metadata.type";
import { WEBSOCKET_EVENT } from "../shared/enums/WebsocketEvent.enum";
import { LOCAL_STORAGE_KEYS } from "../shared/enums/LocalStorage.enum";

@Injectable({
  providedIn: "root",
})
export class SocketIoService implements OnDestroy {
  public socket: Socket;
  public events = new Map();
  public connectionOptions: Partial<ManagerOptions & SocketOptions> = {
    secure: true,
    transports: ["websocket", "polling"],
    rejectUnauthorized: true,
    forceNew: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
    path: "/gateway",
  };
  constructor(private injector: Injector) {
    console.log("SOCKET IO CONNECTION CONSTRUCTOR!");
    this.socket = io(environment.socketIO, this.connectionOptions);
  }

  initConnection = () => {
    try {
      this.socket.connect();

      this.socket.on("connect", () => {
        this.events.forEach((value, key) => {
          this.socket.on(key, () => () => {});
        });
        console.log("SOCKET CONNECTED!", this.socket.id);
      });

      this.socket.on("disconnect", (reason) =>
        console.log("SOCKET DISCONNECTED!", reason)
      );

      this.socket.on("connect_error", (err: Error) =>
        console.error("SOCKET CONNECT ERROR", err)
      );

      this.disableCompanyEvent();
      this.disableUserEvent();
      this.healthEvent();

      this.socket.on("error", (error) => console.error("SOCKET ERROR:", error));
    } catch (err) {
      console.log("Error al establecer la conexion de socket", err);
    }
  };

  connect = () => {
    this.disconnect();
    this.socket.auth = {
      token: localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN),
    };
    this.initConnection();
  };

  disconnect = () => this.socket.removeAllListeners().close().disconnect();

  private disableUserEvent = () => {
    const auth = this.injector.get(AuthenticationService);
    this.listen(WEBSOCKET_EVENT.DISABLED_USER).subscribe(({ userId }) => {
      if (userId === auth.userId) {
        auth.logout();
        Swal.fire({
          icon: "warning",
          title: "Se te ha deshabilitado el acceso",
        });
      }
    });
  };

  private disableCompanyEvent = () => {
    const auth = this.injector.get(AuthenticationService);

    this.listen(WEBSOCKET_EVENT.DISABLED_COMPANY).subscribe(
      ({ companyId }) => {
        if (companyId === auth.companyId || companyId === auth.companyOwnerId) {
          Swal.fire({
            icon: "warning",
            title: "Se te ha deshabilitado el accesso",
          });
          auth.logout();
        }
      },
      (err: HttpErrorResponse) =>
        console.error("Error updatedTask subscriber socket: ", err)
    );
  };

  private healthEvent = () => {
    this.listen(WEBSOCKET_EVENT.HEALTH).subscribe((resp) =>
      console.log("HEALTH ", resp)
    );
  };

  listen = (eventName: WEBSOCKET_EVENT) =>
    new Observable<Metadata>((subscriber: Metadata) => {
      this.events.set(eventName, true);
      this.socket.listeners("a");
      this.socket.on(eventName, (data) => {
        console.log("EVENT EMITTED", eventName, data);
        subscriber.next(data);
      });
    });

  private setConnectionConfig = () => {
    const auth = this.injector.get(AuthenticationService);

    return (this.connectionOptions.auth = {
      company_id: auth.companyId,
      username: auth.user?.username,
      company_owner_id: auth.companyOwnerId,
      role: auth.role,
    });
  };

  ngOnDestroy(): void {
    console.log("CLOSE SOCKET SERVICE!");
    this.disconnect();
  }
}
